import { Component, OnInit, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})

@Component({
    selector: 'app-block-new-login',
    templateUrl: './block-new-login.component.html',
    styleUrls: ['./block-new-login.component.scss'],
    standalone: false
})

export class BlockNewLoginComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  /*home(){
   //this.router.navigate(['service-request/search'])
   window.location.replace(environment.signIn)
  }*/

}
